import React from 'react';
import PropTypes from 'prop-types';

import { InstructionsSection, InstructionsHeading, InstructionsList } from './styles';

const CheckInInstructions = ({ steps, heading }) => (
  <InstructionsSection>
    <InstructionsHeading>{heading}</InstructionsHeading>
    <InstructionsList>
      {steps.map(step => <li key={step}>{step}</li>)}
    </InstructionsList>
  </InstructionsSection>
);

CheckInInstructions.propTypes = {
  steps: PropTypes.instanceOf(Array),
  heading: PropTypes.string,
};

export default CheckInInstructions;
